import i18n from "../i18n";

export const usernameValidation = /^[\w@.+_-]+$/;
export const fullnameValidation = /^[A-zÀ-ÿ\- ]+$/i;
export const emailValidation =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const passwordValidation =
	/^(?=^.{8,}$)(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[@$!%*?&():;#"^_{}[\]'~|<>,./=`\\+-]+).*$/;
export const phoneValidation = /^[\d()+ -]+$/;

export const allowedRoles = ["administrator", "owner"];

export const userRoleOptions = [
	{ value: "INSTALLER", label: i18n.t("user.role.INSTALLER") },
	{ value: "OWNER", label: i18n.t("user.role.OWNER") },
	{ value: "TENANT", label: i18n.t("user.role.TENANT") },
];

export const userRoleOptionsFilter = [
	{ value: "INSTALLER", label: i18n.t("user.role.INSTALLER") },
	{ value: "OWNER", label: i18n.t("user.role.OWNER") },
	{ value: "TENANT", label: i18n.t("user.role.TENANT") },
	{ value: "none", label: i18n.t("user.role.none") },
];

//Leak and alarm alerts are on by default; everything else is off. The cognito-postlogin Lambda
//creates the same defaults at sign-in, so keep the two in step.
export const defaultNotificationConfig = {
	push: {
		sensor_input_flexipad: true,
		sensor_input_flowstop: true,
		sensor_input_ranger: true,
		alarm_active: true,
		relay: false,
		out_of_comms: false,
		battery_low: false,
		mains_power_fail: false,
	},
	email: {
		sensor_input_flexipad: true,
		sensor_input_flowstop: true,
		sensor_input_ranger: true,
		alarm_active: true,
		relay: false,
		out_of_comms: false,
		battery_low: false,
		mains_power_fail: false,
	},
};
